import * as React from 'react';
import * as moment from 'moment';
import { connect } from 'react-redux';
import { flatten, debounce } from 'lodash';

import { IEventMonth, ICalendarState, CalendarActions } from '@adage/ace-calendar';
import { ICalendar } from '@adage/calendar/services/calendar';

import GridMonth from '../components/grid-month';
import ListView from '../views/list-view';

import { IArenaEvent } from "../classes/event";

import Example from '../ex-comp';
import Loader from '../components/loader';

interface DesktopContainerExternalProps {
    allMonths: Array<moment.Moment>;
    calendarMonths: Array<ICalendar<IArenaEvent>>;
    evts: Array<IEventMonth<IArenaEvent>>;
    isMobile: boolean;
}

interface StateToProps {
    endDate: moment.Moment;
    thisMonth: moment.Moment;
}

interface DesktopContainerState {
}

type DesktopContainerProps = DesktopContainerExternalProps & StateToProps;

class DesktopContainer extends React.Component<DesktopContainerProps, DesktopContainerState> {
    /**
     * Lifecycle functions.
     * @param props
     */
    constructor(props: DesktopContainerProps) {
        super(props);
    }

    componentWillMount() {
        if (this.props.isMobile) {
            window.addEventListener("scroll", this.boundScroll);
        }
    }

    //componentWillReceiveProps() {
    //    if (this.props.isMobile) {
    //        window.addEventListener("scroll", this.boundScroll);
    //    } else {
    //        window.removeEventListener("scroll", this.boundScroll);
    //    }
    //}

    componentWillUnmount() {
        if (this.props.isMobile) {
            window.removeEventListener("scroll", this.boundScroll);
        }
    }

    private setupMobileScroll() {
        const events = document.querySelectorAll('div[data-month]');

        let element: Element = null;
        for (let i = 0; i < events.length; ++i) {
            const loc = events[i].getBoundingClientRect().top;

            if (loc > 50)
                break;
            element = events[i];
        }

        if (element) {
            const month = element.getAttribute("data-month");
            CalendarActions.goToMonth(moment(month));
        } else {
            CalendarActions.goToMonth(moment());

        }
    }

    private boundScroll = debounce(this.setupMobileScroll.bind(this), 500, {
        trailing: true,
        leading: false
    });

    /**
     * Render function.
     */
    render() {
        return (
            <div className="desktop-container cal-grid">
                {
                    this.props.isMobile ? <ListView allEvents={this.props.calendarMonths} /> :
                        this.props.allMonths.map((monthMoment, idx) => monthMoment.isSame(this.props.thisMonth, "month") ? <GridMonth key={`${monthMoment.format("MM,YYY")}-desktop`} monthMoment={monthMoment} eventMonth={this.props.calendarMonths[idx]} /> : <div key={`${monthMoment.format("MM,YYY")}-desktop`}></div>)
                }

                {
                    this.props.isMobile ? <Loader /> : null
                }
            </div>

        )
    }
}

function mapStateToProps(state: ICalendarState<IArenaEvent>): StateToProps {
    return {
        endDate: state.endDate,
        thisMonth: state.currentDate,
    }
}


export default connect<StateToProps>(mapStateToProps)(DesktopContainer);


// WEBPACK FOOTER //
// ./app/calendar/components/desktop-container.tsx